import React from "react"
import { datadogRum } from "@datadog/browser-rum"

class ErrorBoundary extends React.Component<{}, { hasError: boolean }> {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    const renderingError = new Error(error.message)
    renderingError.name = "ReactRenderingError"
    renderingError.stack = errorInfo.componentStack
    renderingError.cause = error

    datadogRum.addError(renderingError)
  }

  render() {
    if (this.state.hasError) {
      return <h1>Something went wrong.</h1>
    }

    return <>{this.props.children}</>
  }
}

export const withErrorBoundary =
  (Component) =>
  (props): JSX.Element => (
    <ErrorBoundary>
      <Component {...props} />
    </ErrorBoundary>
  )

export default ErrorBoundary
